// GA4 event dispatch that supports both gtag.js and GTM installs on the
// host page without double-counting.
//
// gtag.js defines window.gtag, which pushes an *array* shape onto
// dataLayer that GTM custom-event triggers ignore. GTM-only installs
// don't define gtag, so we fall back to an *object* push that GTM
// triggers recognize. If neither is present, the call is a no-op.

type GtagFn = (command: string, eventName: string, params?: Record<string, unknown>) => void;

interface GtagWindow extends Window {
  gtag?: GtagFn;
  dataLayer?: unknown[];
}

export function trackEvent(name: string, params: Record<string, unknown> = {}): void {
  if (typeof window === "undefined") return;
  const w = window as GtagWindow;

  if (typeof w.gtag === "function") {
    w.gtag("event", name, params);
    return;
  }

  if (Array.isArray(w.dataLayer)) {
    w.dataLayer.push({ event: name, ...params });
  }
}
